import React from 'react';

import Link from 'next/link';

import { Text } from '@blueprint/text';

import {
    hasPriceQualifierLabel,
    mapPropertyImageResponseToGalleryImages
} from 'listing-details/helpers';
import { ListingPreviewProps } from '../ListingPreview.types';
import {
    CompactAgentLink,
    CompactImageLinkWrapper,
    CompactListingAddress,
    CompactListingDetails,
    CompactListingPreviewCard,
    CompactListingPrice
} from './CompactListingPreview.styles';
import { ListingCounts, ListingImagePreview } from '../..';
import {
    trackPreviewImgClick,
    trackPreviewDescriptionClick,
    trackPreviewBranchClick
} from '../ListingPreview.tracking';

const CompactListingPreview = ({
    listing: {
        branch: { logoUrl, branchDetailsUri, name },
        counts,
        displayAddress,
        pricing,
        propertyImage
    },
    detailsUri
}: ListingPreviewProps) => {
    const listingImg = mapPropertyImageResponseToGalleryImages(
        '120px',
        propertyImage || [],
        ['original']
    )[0];

    const details = detailsUri ? detailsUri : '';
    const { label } = pricing;

    return (
        <CompactListingPreviewCard data-testid="compact-listing-preview">
            <Link href={details} passHref>
                <CompactImageLinkWrapper
                    data-testid="compact-listing-preview-image"
                    onClick={trackPreviewImgClick}
                >
                    <ListingImagePreview image={listingImg} compact={true} />
                </CompactImageLinkWrapper>
            </Link>
            <Link href={details} passHref>
                <CompactListingDetails
                    data-testid="compact-listing-preview-description"
                    onClick={trackPreviewDescriptionClick}
                >
                    {hasPriceQualifierLabel(pricing.priceQualifierLabel) ? (
                        <Text data-testid="price-qualifier">
                            {pricing.priceQualifierLabel}
                        </Text>
                    ) : null}
                    <CompactListingPrice>{label}</CompactListingPrice>
                    <ListingCounts data={counts} compact={true} />
                    {displayAddress && (
                        <CompactListingAddress>
                            {displayAddress?.split(',')[0]}
                        </CompactListingAddress>
                    )}
                </CompactListingDetails>
            </Link>

            {logoUrl && (
                <Link href={branchDetailsUri || ''} passHref>
                    <CompactAgentLink
                        data-testid="compact-listing-preview-branch"
                        onClick={trackPreviewBranchClick}
                    >
                        <img src={logoUrl} alt={name} loading="lazy" />
                    </CompactAgentLink>
                </Link>
            )}
        </CompactListingPreviewCard>
    );
};

export default CompactListingPreview;
